function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  fill: "#396EFF",
  fillRule: "nonzero"
}, React.createElement("g", null, React.createElement("path", {
  fillOpacity: 0.2,
  d: "M17.696 12.686c0 3.451-2.798 6.25-6.25 6.25h-.267c-3.451 0-6.25-2.799-6.25-6.25 0-2.863-.017-2.953.063-3.52C5.42 6.133 8.028 3.8 11.179 3.8h.267c3.431 0 6.205 2.76 6.25 6.166v2.72z",
  transform: "translate(-699 -161) translate(699 161)"
}), React.createElement("path", {
  d: "M11.446 3.563c3.587 0 6.558 2.694 6.994 6.165h2.721c.442 0 .8.359.8.8 0 .442-.358.8-.8.8h-2.666v1.92c0 3.888-3.162 7.05-7.05 7.05-4.52 0-7.316-3.435-7.316-7.05v-2.636c0-3.624 2.805-7.05 7.317-7.05zm5.45 7.765H5.728v1.92c0 3.006 2.445 5.45 5.45 5.45h.267c3.004 0 5.45-2.444 5.45-5.45v-1.92zm-7.515.982c.442 0 .8.358.8.8v.255c0 .442-.358.8-.8.8-.442 0-.8-.358-.8-.8v-.255c0-.442.358-.8.8-.8zm3.862 0c.442 0 .8.358.8.8v.255c0 .442-.358.8-.8.8-.442 0-.8-.358-.8-.8v-.255c0-.442.358-.8.8-.8zM10.75 5.475H9.464v3.81h1.286V8.014h1.285v1.27h1.286V5.476h-1.285v1.269h-1.287l.001-1.269z",
  transform: "translate(-699 -161) translate(699 161)"
}))));

var SvgZeroMan = function SvgZeroMan(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgZeroMan, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/zero-man.50b1bd81.svg";
export { ForwardRef as ReactComponent };